import { type SetStateAction, useCallback } from 'react';

import { useSetWillRedirectOnLoad } from '../use-set-will-redirect-on-load';

export const useWithSetWillRedirectOnLoad = <P extends any[]>(
	f: ((...args: P) => void) | undefined,
	value: SetStateAction<boolean>,
	condition = true,
): ((...args: P) => void) => {
	const setWillRedirectOnLoad = useSetWillRedirectOnLoad();

	return useCallback(
		(...args: P) => {
			if (condition) {
				setWillRedirectOnLoad(value);
			}

			f?.(...args);
		},
		[condition, f, setWillRedirectOnLoad, value],
	);
};
